import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { envAwarePost } from "../util/util";


export const getPaymentsTrainer = createAsyncThunk(
    "getTrainerPayments",
    async (payload) => (
        envAwarePost('api/financials/api.php/', { ...payload, action: "getPaymentsTrainer" })
    )
)

export const getPaymentsClient = createAsyncThunk(
    "getClientPayments",
    async (payload) => (
        envAwarePost('api/financials/api.php/', { ...payload, action: "getPaymentsClient" })
    )
)

export const getPackagesClient = createAsyncThunk(
    "getPackagesClient",
    async (payload) => (
        envAwarePost('api/financials/api.php/', { ...payload, action: "getPackagesClient" })
    )
)


const paymentSlice = createSlice({
    name: "paymentSlice",
    initialState: {
        paymentList: [],
        paymentStatus: "idle",
        maxClients: "",
        pageAddress: "",
        premiumAccount: 1,
        packages: [],
        sessionRate: "",
        sessionRatePresentmentCurrencyId:1,
        url: "",
        link: "",
        paymentListSuccess: true,
        sessions:[]
    },
    reducers: {
        updatePackage: (state, action) => {
            const { id, updatedQuantity } = action.payload;
            state.packages.map(item => {
                if (item.id === id) {
                    item.quantity = updatedQuantity
                }
                return item;
            })
        }
    },

    extraReducers: {
        [getPaymentsTrainer.fulfilled]: (state, action) => {
            const { paymentDetails, pageAddress, premium, url, link } = action.payload.data;
            const { success } = action.payload
            state.paymentStatus = "idle";
            if (success === "1") {
                state.url = url;
                state.paymentList = paymentDetails;
                state.pageAddress = pageAddress;
                state.paymentListSuccess = true
            } else {
                state.paymentLink = link;
                state.paymentListSuccess = false;
                state.premiumAccount = premium;
            }
        },
        [getPaymentsTrainer.pending]: (state, action) => {
            state.paymentStatus = "loading";
        },
        [getPaymentsClient.fulfilled]: (state, action) => {
            const { success } = action.payload;
            state.paymentStatus = "idle";
            if (success === "1") {
                const { 
                    paymentDetails, 
                    sessionRate,
                    session_rate_presentment_currency_id
                } = action.payload.data;
                state.sessionRate = sessionRate;
                state.paymentList = paymentDetails;
                state.sessionRatePresentmentCurrencyId = session_rate_presentment_currency_id
            }
        },
        [getPaymentsClient.pending]: (state, action) => {
            state.paymentStatus = "loading";
        },
        [getPackagesClient.fulfilled]: (state, action) => {
            const { success } = action.payload;
            if (success === "1") {
                let { packages } = action.payload.data;
                if (packages) {
                    packages = packages.map(item => {
                        return { ...item, quantity: "" }
                    })
                    state.packages = packages;
                }
            }
        },
    }
});

export const { updatePackage } = paymentSlice.actions;

export default paymentSlice.reducer;




